import { Navigate } from "react-router-dom";

type ProtectedRouteProps = {
  children: JSX.Element;
};

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = localStorage.getItem("token")
    ? JSON.parse(localStorage.getItem("token") || "")
    : null;

  if (!token) {
    return <Navigate to="/auth/login" />;
  }

  return children;
};
